export const lookingForOptions = [
  { label: "Just sell for now", value: "Just sell for now" },
  {
    label:
      "Sell, then buy, and also take advantage of the Sale2Sold Buyer Rebate Program",
    value:
      "Sell, then buy, and also take advantage of the Sale2Sold Buyer Rebate Program",
  },
  {
    label:
      "I am just researching my options on what I could potentially sell for",
    value:
      "I am just researching my options on what I could potentially sell for",
  },
];

export const genericLookingForOptions = [
  { label: "Just sell for now", value: "Just sell for now" },
  {
    label: "Sell then buy",
    value: "Sell then buy",
  },
  {
    label:
      "I am just researching my options on what I could potentially sell for",
    value:
      "I am just researching my options on what I could potentially sell for",
  },
];

export const workingWithOtherAgentOptions = [
  {
    label: "Yes. But the agreement is coming to an end with no sale in sight",
    value: "Yes. But the agreement is coming to an end with no sale in sight",
  },
  {
    label:
      "Yes. But not currently, as I tried to sell my home in the past with no luck",
    value:
      "Yes. But not currently, as I tried to sell my home in the past with no luck",
  },
  {
    label: "Nope. I am currently not working with any other Realtor/Brokerage",
    value: "Nope. I am currently not working with any other Realtor/Brokerage",
  },
  {
    label:
      "No, but I have been shopping around for the best realtor to maximize my home’s value",
    value:
      "No, but I have been shopping around for the best realtor to maximize my home’s value",
  },
];

export const movingTimelineOptions = [
  {
    label:
      "I/we have already found our dream home or need to sell it yesterday",
    value:
      "I/we have already found our dream home or need to sell it yesterday",
  },
  {
    label: "I/we are actively looking to move ASAP",
    value: "I/we are actively looking to move ASAP",
  },
  {
    label: "I/we are planning a move within 3 months",
    value: "I/we are planning a move within 3 months",
  },
  {
    label: "I/we are planning a move within 3 to 6 months",
    value: "I/we are planning a move within 3 to 6 months",
  },
  {
    label: "I/we are planning a move in 6+ months",
    value: "I/we are planning a move in 6+ months",
  },
];

export const homeTypeOptions = [
  { label: "Condo", value: "Condo" },
  { label: "Condo Town", value: "Condo Town" },
  { label: "Townhouse", value: "Townhouse" },
  { label: "Semi-Detached", value: "Semi-Detached" },
  { label: "Detached", value: "Detached" },
  { label: "Other", value: "Other" },
];

export const condoStyleOptions = [
  { label: "Lower Floor Range", value: "Lower Floor Range" },
  { label: "Middle Floor Range", value: "Middle Floor Range" },
  { label: "Higher Floor Range", value: "Higher Floor Range" },
  { label: "Penthouse or Double Floor", value: "Penthouse or Double Floor" },
];

export const condoTownhouseStyleOptions = [
  { label: "Traditional Townhouse", value: "Traditional Townhouse" },
  { label: "Three-Story Townhouse", value: "Three-Story Townhouse" },
  { label: "Bungalow Loft Towns", value: "Bungalow Loft Towns" },
  { label: "Stacked Townhouse", value: "Stacked Townhouse" },
  { label: "Back-to-Back Townhouse", value: "Back-to-Back Townhouse" },
  { label: "Split Level Townhouse", value: "Split Level Townhouse" },
  { label: "Live/Work Townhouse", value: "Live/Work Townhouse" },
];

export const detachedOrSemidetachedStyleOptions = [
  { label: "Bungalow", value: "Bungalow" },
  { label: "Split Level", value: "Split Level" },
  { label: "Bi-Level", value: "Bi-Level" },
  { label: "4 Level Split", value: "4 Level Split" },
  { label: "2 Story and Above", value: "2 Story and Above" },
  { label: "2 Story Split", value: "2 Story Split" },
];

export const sqftOptions = [
  { label: "Not Sure", value: "Not Sure" },
  { label: "Up to 700 Square Feet", value: "Up to 700 Square Feet" },
  {
    label: "Between 701 Square Feet and 1100 Square Feet",
    value: "Between 701 Square Feet and 1100 Square Feet",
  },
  {
    label: "Between 1,100 Square Feet and 1,500 Square Feet",
    value: "Between 1,100 Square Feet and 1,500 Square Feet",
  },
  {
    label: "Between 1,500 Square Feet and 2,000 Square Feet",
    value: "Between 1,500 Square Feet and 2,000 Square Feet",
  },
  {
    label: "Between 2,000 Square Feet and 2,500 Square Feet",
    value: "Between 2,000 Square Feet and 2,500 Square Feet",
  },
  {
    label: "Between 2,500 Square Feet and 3,000 Square Feet",
    value: "Between 2,500 Square Feet and 3,000 Square Feet",
  },
  {
    label: "Between 3,000 Square Feet and 3,500 Square Feet",
    value: "Between 3,000 Square Feet and 3,500 Square Feet",
  },
  {
    label: "Between 3,500 Square Feet and 5,000 Square Feet",
    value: "Between 3,500 Square Feet and 5,000 Square Feet",
  },
  { label: "Above 5,000 Square Feet", value: "Above 5,000 Square Feet" },
];

export const priceRangeOptions = [
  { label: "Under $500 K", value: "Under $500 K" },
  { label: "$500 K to $750 K", value: "$500 K to $750 K" },
  { label: "$750 K to $1 Mil", value: "$750 K to $1 Mil" },
  { label: "$1 Mil to $1.25 Mil", value: "$1 Mil to $1.25 Mil" },
  { label: "$1.25 Mil to $1.5 Mil", value: "$1.25 Mil to $1.5 Mil" },
  { label: "$1.5 Mil to $2 Mil", value: "$1.5 Mil to $2 Mil" },
  { label: "Above $2 Mil", value: "Above $2 Mil" },
];

export const propTpriceRangeOptions = [
  { label: "Under $500K", value: "Under $500 K" },
  { label: "$500K to $750K", value: "$500 K to $750 K" },
  { label: "$750K to $1M", value: "$750 K to $1 Mil" },
  { label: "$1M to $1.25M", value: "$1M to $1.25M" },
  { label: "$1.25M to $1.5M", value: "$1.25M to $1.5M" },
  { label: "$1.5M to $2M", value: "$1.5M to $2M" },
  { label: "$2M to $5M", value: "$2M to $5M" },
  { label: "$5M to $10M", value: "$5M to $10M" },
  { label: "$10M to $30M", value: "$10M to $30M" },
  { label: "Above $30M", value: "Above $30M" },
];

export const sellerBedOptions = [
  { label: "Studio", value: "Studio" },
  { label: "1 Bed", value: "1 Bed" },
  { label: "2 Beds", value: "2 Beds" },
  { label: "3 Beds", value: "3 Beds" },
  { label: "4 Beds", value: "4 Beds" },
  { label: "5 Beds", value: "5 Beds" },
  { label: "6 Beds", value: "6 Beds" },
  { label: "7 Beds", value: "7 Beds" },
  { label: "8 Beds and above", value: "8 Beds and above" },
];

export const sellerBathOptions = [
  { label: "1 Bathrooms and above", value: "1 Bathrooms and above" },
  { label: "2 Bathrooms and above", value: "2 Bathrooms and above" },
  { label: "3 Bathrooms and above", value: "3 Bathrooms and above" },
  { label: "4 Bathrooms and above", value: "4 Bathrooms and above" },
  { label: "5 Bathrooms and above", value: "5 Bathrooms and above" },
  { label: "6 Bathrooms and above", value: "6 Bathrooms and above" },
  { label: "7 Bathrooms and above", value: "7 Bathrooms and above" },
  { label: "8 Bathrooms and above", value: "8 Bathrooms and above" },
];

export const bedOptions = [
  { label: "Any", value: "Any" },
  { label: "1 Bed and above", value: "1 Bed and above" },
  { label: "2 Beds and above", value: "2 Beds and above" },
  { label: "3 Beds and above", value: "3 Beds and above" },
  { label: "4 Beds and above", value: "4 Beds and above" },
  { label: "5 Beds and above", value: "5 Beds and above" },
  { label: "6 Beds and above", value: "6 Beds and above" },
  { label: "7 Beds and above", value: "7 Beds and above" },
  { label: "8 Beds and above", value: "8 Beds and above" },
];

export const bathOptions = [
  { label: "Any", value: "Any" },
  { label: "1 Bathroom and above", value: "1 Bathroom and above" },
  { label: "2 Bathrooms and above", value: "2 Bathrooms and above" },
  { label: "3 Bathrooms and above", value: "3 Bathrooms and above" },
  { label: "4 Bathrooms and above", value: "4 Bathrooms and above" },
  { label: "5 Bathrooms and above", value: "5 Bathrooms and above" },
  { label: "6 Bathrooms and above", value: "6 Bathrooms and above" },
];

export const garageOptions = [
  { label: "Single Car Garage", value: "Single Car Garage" },
  { label: "Double Car Garage", value: "Double Car Garage" },
  { label: "Triple Car Garage", value: "Triple Car Garage" },
  { label: "1 Parking Space (Condo)", value: "1 Parking Space (Condo)" },
  { label: "2 Parking Spaces (Condo)", value: "2 Parking Spaces (Condo)" },
  { label: "3+ Parking Spaces (Condo)", value: "3+ Parking Spaces (Condo)" },
];

export const basementOptions = [
  {
    label: "Yes. I finished my Basement after I bought it",
    value: "Yes. I finished my Basement after I bought it",
  },
  {
    label: "Yes. I bought this home with a Finished Basement",
    value: "Yes. I bought this home with a Finished Basement",
  },
  {
    label: "No. But it has a partially Finished Basement",
    value: "No. But it has a partially Finished Basement",
  },
  {
    label:
      "No. This home has an unfinished basement waiting for the new owner’s personal touch",
    value:
      "No. This home has an unfinished basement waiting for the new owner’s personal touch",
  },
  {
    label: "No. This home doesn’t have a basement",
    value: "No. This home doesn’t have a basement",
  },
];

export const upgradesOptions = [
  {
    label: "Yes. I spent between 5 K to 50 K in Upgrades",
    value: "Yes. I spent between 5 K to 50 K in Upgrades",
  },
  {
    label: "Yes. I spent between 50 K to 100 K in Upgrades",
    value: "Yes. I spent between 50 K to 100 K in Upgrades",
  },
  {
    label: "Yes. I spent between 100 K to 200 K in Upgrades",
    value: "Yes. I spent between 100 K to 200 K in Upgrades",
  },
  {
    label: "Yes. I spent between 200 K to 300 K in Upgrades",
    value: "Yes. I spent between 200 K to 300 K in Upgrades",
  },
  {
    label: "No. This home is just the way the day we moved in.",
    value: "No. This home is just the way the day we moved in.",
  },
];

export const homeConditionOptions = [
  {
    label: "It's already amazing with no work required",
    value: "It's already amazing with no work required",
  },
  {
    label: "A little TLC won’t hurt, but nothing major",
    value: "A little TLC won’t hurt, but nothing major",
  },
  {
    label: "You could say that there’s some serious work it requires",
    value: "You could say that there’s some serious work it requires",
  },
  {
    label: "It's best to simply tear it down and rebuild better",
    value: "It's best to simply tear it down and rebuild better",
  },
];

export const homeAgeOptions = [
  { label: "It's Brand New", value: "It's Brand New" },
  { label: "Between 0 and 5 Years", value: "Between 0 and 5 Years" },
  { label: "Between 6 and 15 Years", value: "Between 6 and 15 Years" },
  { label: "Between 16 and 30 Years", value: "Between 16 and 30 Years" },
  { label: "Between 31 and 50 Years", value: "Between 31 and 50 Years" },
  { label: "Between 51 and 100 Years", value: "Between 51 and 100 Years" },
  { label: "It’s a 101 Years and Above", value: "It’s a 101 Years and Above" },
];

export const meetingOptions = [
  {
    label:
      "Let's meet in person at my home to get an in-depth Home Analysis and the most value out of our meeting",
    value:
      "Let's meet in person at my home to get an in-depth Home Analysis and the most value out of our meeting",
  },
  {
    label: "Let's meet outside somewhere or at the Sale2Sold Office to discuss",
    value: "Let's meet outside somewhere or at the Sale2Sold Office to discuss",
  },
  {
    label:
      "Let's do a Video Meetup using Zoom/Google Meet/Whatsapp to tour my home remotely",
    value:
      "Let's do a Video Meetup using Zoom/Google Meet/Whatsapp to tour my home remotely",
  },
  {
    label:
      "Let's do a phone call first and see how Sale2Sold can help me Sell my home for top dollar",
    value:
      "Let's do a phone call first and see how Sale2Sold can help me Sell my home for top dollar",
  },
];

export const genericSellerMeetingOptions = [
  {
    label:
      "Let's meet in person at my home to get an in-depth Home Analysis and the most value out of our meeting",
    value:
      "Let's meet in person at my home to get an in-depth Home Analysis and the most value out of our meeting",
  },
  {
    label: "Let's meet outside somewhere or at our Office to discuss",
    value: "Let's meet outside somewhere or at our  Office to discuss",
  },
  {
    label:
      "Let's do a Video Meetup using Zoom/Google Meet/Whatsapp to tour my home remotely",
    value:
      "Let's do a Video Meetup using Zoom/Google Meet/Whatsapp to tour my home remotely",
  },
  {
    label:
      "Let's do a phone call first and see how you can help me Sell my home for top dollar",
    value:
      "Let's do a phone call first and see how you can help me Sell my home for top dollar",
  },
];

export const sellBeforeBuyingOptions = [
  {
    label: "Yes. I am also interested in your $5,900 Seller Listing",
    value: "Yes. I am also interested in your $5,900 Seller Listing",
  },
  {
    label: "Yes. But I am already selling with another Realtor.",
    value: "Yes. But I am already selling with another Realtor.",
  },
  {
    label: "Yes. But I am in the final stages of Closings on my Current Home.",
    value: "Yes. But I am in the final stages of Closings on my Current Home.",
  },
  {
    label: "No. I have already sold, and I am actively looking to buy.",
    value: "No. I have already sold, and I am actively looking to buy.",
  },
  {
    label: "No. I am a first-time home buyer.",
    value: "No. I am a first-time home buyer.",
  },
];

export const buyerMovingOptions = [
  {
    label:
      "I/we might have already found our dream home and want to get your Buyer Rebate",
    value:
      "I/we might have already found our dream home and want to get your Buyer Rebate",
  },
  {
    label: "I/we are actively looking to move ASAP",
    value: "I/we are actively looking to move ASAP",
  },
  {
    label: "I/we are planning a move within 3 months",
    value: "I/we are planning a move within 3 months",
  },
  {
    label: "I/we are planning a move within 3 to 6 months",
    value: "I/we are planning a move within 3 to 6 months",
  },
  {
    label: "I/we are planning a move in 6+ months",
    value: "I/we are planning a move in 6+ months",
  },
];

export const buyerHomeTypeOptions = [
  { label: "Any", value: "Any" },
  { label: "Condo", value: "Condo" },
  { label: "Condo Town", value: "Condo Town" },
  { label: "Townhouse", value: "Townhouse" },
  { label: "Semi-Detached", value: "Semi-Detached" },
  { label: "Detached", value: "Detached" },
  { label: "Other", value: "Other" },
];

export const buyerSituationOptions = [
  {
    label: "I am looking for a starter home, I can proudly call my own",
    value: "I am looking for a starter home, I can proudly call my own",
  },
  {
    label: "I am looking for my Luxurious Forever Home",
    value: "I am looking for my Luxurious Forever Home",
  },
  {
    label: "I am looking to downsize out of my oversized home",
    value: "I am looking to downsize out of my oversized home",
  },
  {
    label: "I am looking for a House Hacking Style of Home Ownership",
    value: "I am looking for a House Hacking Style of Home Ownership",
  },
  {
    label:
      "I am looking for first access to Distressed / Power of Sale Homes coming on the market",
    value:
      "I am looking for first access to Distressed / Power of Sale Homes coming on the market",
  },
  {
    label: "I am particularly interested in off-market or FSBO deals",
    value: "I am particularly interested in off-market or FSBO deals",
  },
  {
    label: "I am an Investor Looking for Positive Cash Flow or Equity Growth",
    value: "I am an Investor Looking for Positive Cash Flow or Equity Growth",
  },
];

export const buyerInterestedInOptions = [
  {
    label: "Any of these suits me",
    value: "Any of these suits me",
  },
  {
    label:
      "I want a Preconstruction Home with a deposit structure and longer closing date",
    value:
      "I want a Preconstruction Home with a deposit structure and longer closing date",
  },
  {
    label: "I want a Brand new home with Shorter closing",
    value: "I want a Brand new home with Shorter closing",
  },
  {
    label:
      "I am looking for a Gently Used home that I can brighten up with my touch",
    value:
      "I am looking for a Gently Used home that I can brighten up with my touch",
  },
];

export const spokenWithAdvisorOptions = [
  {
    label: "Yes! I have already been pre-approved",
    value: "Yes! I have already been pre-approved",
  },
  {
    label: "Yes! It’s in the works",
    value: "Yes! It’s in the works",
  },
  {
    label: "No. I am looking for agents and will need recommendations",
    value: "No. I am looking for agents and will need recommendations",
  },
  {
    label: "No. But I know a guy",
    value: "No. But I know a guy",
  },
];

export const workingWithAgentOptions = [
  {
    label:
      "No. And I need some guidance and want to benefit from the Buyer Rebate",
    value:
      "No. And I need some guidance and want to benefit from the Buyer Rebate",
  },
  {
    label: "Yes. But I haven’t signed a Buyer Representation Agreement",
    value: "Yes. But I haven’t signed a Buyer Representation Agreement",
  },
  {
    label: "Yes. I have a Buyer Representation Agreement that’s Expiring Soon",
    value: "Yes. I have a Buyer Representation Agreement that’s Expiring Soon",
  },
  {
    label: "Yes. But I am simply not happy with the homes I am being shown",
    value: "Yes. But I am simply not happy with the homes I am being shown",
  },
];

export const rentWorkingWithAgentOptions = [
  {
    label: "No. And I need some help",
    value: "No. And I need some help",
  },
  {
    label: "Yes. But I haven’t signed a Buyer Representation Agreement",
    value: "Yes. But I haven’t signed a Buyer Representation Agreement",
  },
  {
    label: "Yes. I have a Buyer Representation Agreement that’s Expiring Soon",
    value: "Yes. I have a Buyer Representation Agreement that’s Expiring Soon",
  },
  {
    label: "Yes. But I am simply not happy with the homes I am being shown",
    value: "Yes. But I am simply not happy with the homes I am being shown",
  },
];

export const buyerMeetingOptions = [
  {
    label: "Let's meet in person at my home",
    value: "Let's meet in person at my home",
  },
  {
    label: "Let's meet outside somewhere or at the Sale2Sold Office to discuss",
    value: "Let's meet outside somewhere or at the Sale2Sold Office to discuss",
  },
  {
    label: "Let's do a Video Meetup using Zoom/Google Meet/Whatsapp",
    value: "Let's do a Video Meetup using Zoom/Google Meet/Whatsapp",
  },
  {
    label:
      "Let's do a phone call first and see how Sale2Sold can help me buy my home",
    value:
      "Let's do a phone call first and see how Sale2Sold can help me buy my home",
  },
];

export const genericBuyerMeetingOptions = [
  {
    label: "Let's meet in person at my home",
    value: "Let's meet in person at my home",
  },
  {
    label: "Let's meet outside somewhere or at our Office to discuss",
    value: "Let's meet outside somewhere or at our Office to discuss",
  },
  {
    label: "Let's do a Video Meetup using Zoom/Google Meet/Whatsapp",
    value: "Let's do a Video Meetup using Zoom/Google Meet/Whatsapp",
  },
  {
    label:
      "Let's do a phone call first and see how you can help me buy my home",
    value:
      "Let's do a phone call first and see how you can help me buy my home",
  },
];

export const buyerSincerityOptions = [
  {
    label: "They are actively looking to buy or sell ASAP",
    value: "They are actively looking to buy or sell ASAP",
  },
  {
    label: "They are planning a move within 3 months",
    value: "They are planning a move within 3 months",
  },
  {
    label: "They are planning a move within 3 to 6 months",
    value: "They are planning a move within 3 to 6 months",
  },
  {
    label: "They are planning a move in 6+ months",
    value: "They are planning a move in 6+ months",
  },
];

export const leadsLookingOptions = [
  {
    label: "Buy a Home",
    value: "buy",
  },
  {
    label: "Sell a Home",
    value: "sell",
  },
  {
    label: "Buy & Sell a Home",
    value: "buy_and_sell",
  },
];

export const rentHomeTypeOptions = [
  {
    label: "Any",
    value: "Any",
  },
  {
    label: "Hostel / Shared Home Style Room",
    value: "Hostel / Shared Home Style Room",
  },
  {
    label: "Private Home Apartment",
    value: "Private Home Apartment",
  },
  {
    label: "Condo",
    value: "Condo",
  },
  {
    label: "Condo Town",
    value: "Condo Town",
  },
  {
    label: "Townhouse",
    value: "Townhouse",
  },
  {
    label: "Semi-Detached",
    value: "Semi-Detached",
  },
  {
    label: "Detached",
    value: "Detached",
  },
  {
    label: "Other",
    value: "Other",
  },
];

export const rentalSituationOptions = [
  {
    label: "I am looking for a starter Rental home",
    value: "I am looking for a starter Rental home",
  },
  {
    label: "I am looking for a Luxurious Rental Home",
    value: "I am looking for a Luxurious Rental Home",
  },
  {
    label: "I am looking to downsize out of my oversized home",
    value: "I am looking to downsize out of my oversized home",
  },
  {
    label:
      "I am new in the city or arriving soon in the city and require assistance",
    value:
      "I am new in the city or arriving soon in the city and require assistance",
  },
];

export const rentalBudgetOptions = [
  {
    label: "Under $ 1,000 K",
    value: "Under $ 1,000 K",
  },
  {
    label: "Between $ 1,000 to $ 1,250",
    value: "Between $ 1,000 to $ 1,250",
  },
  {
    label: "Between $ 1,250 to $ 1,500",
    value: "Between $ 1,250 to $ 1,500",
  },
  {
    label: "Between $ 1,500 to $ 1,750",
    value: "Between $ 1,500 to $ 1,750",
  },
  {
    label: "Between $ 1,750 to $ 2,000",
    value: "Between $ 1,750 to $ 2,000",
  },
  {
    label: "Between $ 2,000 to $ 2,500",
    value: "Between $ 2,000 to $ 2,500",
  },
  {
    label: "Between $ 2,500 to $ 3,000",
    value: "Between $ 2,500 to $ 3,000",
  },
  {
    label: "Between $ 3,000 to $ 3,500",
    value: "Between $ 3,000 to $ 3,500",
  },
  {
    label: "Between $ 3,500 to $ 4,000",
    value: "Between $ 3,500 to $ 4,000",
  },
  {
    label: "Between $ 4,000 to $ 4,500",
    value: "Between $ 4,000 to $ 4,500",
  },
  {
    label: "Between $ 4,500 to $ 5,000",
    value: "Between $ 4,500 to $ 5,000",
  },
  {
    label: "Between $ 5,000 to $ 7,500",
    value: "Between $ 5,000 to $ 7,500",
  },
  {
    label: "Between $ 7,500 to $ 10,000",
    value: "Between $ 7,500 to $ 10,000",
  },
  {
    label: "Above $ 10,000",
    value: "Above $ 10,000",
  },
];

export const rentalMeetingOptions = [
  {
    label: "Let's meet in person at my home",
    value: "Let's meet in person at my home",
  },
  {
    label: "Let's meet outside somewhere or at the Sale2Sold Office to discuss",
    value: "Let's meet outside somewhere or at the Sale2Sold Office to discuss",
  },
  {
    label: "Let's do a Video Meetup using Zoom/Google Meet/Whatsapp",
    value: "Let's do a Video Meetup using Zoom/Google Meet/Whatsapp",
  },
  {
    label:
      "Let's do a phone call first and see how Sale2Sold can help me Rent my Home",
    value:
      "Let's do a phone call first and see how Sale2Sold can help me Rent my Home",
  },
];

export const genericRentalMeetingOptions = [
  {
    label: "Let's meet in person at my home",
    value: "Let's meet in person at my home",
  },
  {
    label: "Let's meet outside somewhere or at our Office to discuss",
    value: "Let's meet outside somewhere or at our Office to discuss",
  },
  {
    label: "Let's do a Video Meetup using Zoom/Google Meet/Whatsapp",
    value: "Let's do a Video Meetup using Zoom/Google Meet/Whatsapp",
  },
  {
    label:
      "Let's do a phone call first and see how you can help me Rent my Home",
    value:
      "Let's do a phone call first and see how you can help me Rent my Home",
  },
];

export const genericSellBeforeBuyingOptions = [
  {
    label: "Yes. I would need help in selling also.",
    value: "Yes. I would need help in selling also.",
  },
  {
    label: "Yes. But I am already selling with another Realtor.",
    value: "Yes. But I am already selling with another Realtor.",
  },
  {
    label: "Yes. But I am in the final stages of Closings on my Current Home.",
    value: "Yes. But I am in the final stages of Closings on my Current Home.",
  },
  {
    label: "No. I have already sold, and I am actively looking to buy.",
    value: "No. I have already sold, and I am actively looking to buy.",
  },
  {
    label: "No. I am an active property investor, looking for more deals.",
    value: "No. I am an active property investor, looking for more deals.",
  },
  {
    label: "No. I am a first-time home buyer.",
    value: "No. I am a first-time home buyer.",
  },
];

export const multiFormCategory = [
  { label: "I am a home buyer", value: "Buyer" },
  { label: "I am a home seller", value: "Seller" },
  { label: "I am looking to rent a home", value: "rent" },
  {
    label: "I am looking for the lead referral program",
    value: "leadreferall",
  },
];

export const propDetailsHelpOptions = [
  {
    value: "I am an Investor looking for great Real Estate deals.",
    label: "I am an Investor looking for great Real Estate deals.",
  },
  {
    value: "I am a seller looking to offload some of my Portfolio.",
    label: "I am a seller looking to offload some of my Portfolio.",
  },
  {
    value: "I am a land owner looking to connect with Investors.",
    label: "I am a land owner looking to connect with Investors.",
  },
  {
    value: "I am looking to get into development.",
    label: "I am looking to get into development.",
  },
  {
    value: "I am looking for distressed or power of sale properties.",
    label: "I am looking for distressed or power of sale properties.",
  },
  {
    value: "I am looking for JV partners for a deal.",
    label: "I am looking for JV partners for a deal.",
  },
  {
    value: "I am a wholeseller and have properties.",
    label: "I am a wholeseller and have properties.",
  },
  {
    value: "I am looking for fix and flip or Brrrr properties.",
    label: "I am looking for fix and flip or Brrrr properties.",
  },
];

export const interestedInOptions = [
  { value: "Commercial", label: "Commercial" },
  { value: "Industrial", label: "Industrial" },
  { value: "Multi family", label: "Multi family" },
  { value: "Single family", label: "Single family" },
  { value: "FSBO or Off-Market Deals", label: "FSBO or Off-Market Deals" },
  {
    value: "Land banking or development land",
    label: "Land banking or development land",
  },
  { value: "Other", label: "Other" },
];

export const propertyClassOptions = [
  { value: "Class A", label: "Class A" },
  { value: "Class B", label: "Class B" },
  { value: "Class c", label: "Class C" },
];

export const transactOptions = [
  { value: "asap", label: "asap" },
  { value: "1-3 months", label: "1-3 months" },
  { value: "3-6 months", label: "3-6 months" },
  { value: "6 months to 1 year", label: "6 months to 1 year" },
  { value: "1 year plus", label: "1 year plus" },
];

export const financingOptions = [
  { value: "I have to figure this out", label: "I have to figure this out" },
  { value: "I have arranged funding", label: "I have arranged funding" },
  {
    value: "I have to get creative financing",
    label: "I have to get creative financing",
  },
  {
    value: "Currently in the process",
    label: "Currently in the process",
  },
];
